import { useContext, useEffect } from 'react';
import { AuthContext } from '../../context/AuthContext';
import api from '../../api';

const ACCESS_WINDOW_MS = 30 * 60 * 1000;
const PRESENCE_HEARTBEAT_MS = 60 * 1000;

export default function AccessVisitTracker() {
  const { session } = useContext(AuthContext);
  useEffect(() => {
    const username = session?.username || localStorage.getItem('username') || '';
    const storage = username ? localStorage : sessionStorage;
    const key = `mycommunity-access:last-recorded:${username || 'anonymous'}`;
    let inFlight = false;

    const recordIfDue = () => {
      if (inFlight || !navigator.onLine || document.visibilityState === 'hidden') return;
      const lastRecorded = Number(storage.getItem(key) || 0);
      if (Number.isFinite(lastRecorded) && Date.now() - lastRecorded < ACCESS_WINDOW_MS) return;
      inFlight = true;
      api.post('/api/public/access-analytics/visit', {})
        .then(() => storage.setItem(key, String(Date.now())))
        .catch(() => {})
        .finally(() => { inFlight = false; });
    };

    const heartbeat = () => {
      if (!username || inFlight || !navigator.onLine || document.visibilityState === 'hidden') return;
      inFlight = true;
      api.post('/api/public/access-analytics/visit', {})
        .then(() => {
          const lastRecorded = Number(storage.getItem(key) || 0);
          if (!Number.isFinite(lastRecorded) || Date.now() - lastRecorded >= ACCESS_WINDOW_MS) {
            storage.setItem(key, String(Date.now()));
          }
        })
        .catch(() => {})
        .finally(() => { inFlight = false; });
    };

    recordIfDue();
    const activityEvents = ['pointerdown', 'keydown', 'touchstart', 'focus'];
    activityEvents.forEach(event => window.addEventListener(event, recordIfDue, { passive: true }));
    const onVisibilityChange = () => { if (document.visibilityState === 'visible') recordIfDue(); };
    document.addEventListener('visibilitychange', onVisibilityChange);
    const heartbeatTimer = username ? window.setInterval(heartbeat, PRESENCE_HEARTBEAT_MS) : null;
    return () => {
      activityEvents.forEach(event => window.removeEventListener(event, recordIfDue));
      document.removeEventListener('visibilitychange', onVisibilityChange);
      if (heartbeatTimer) window.clearInterval(heartbeatTimer);
    };
  }, [session?.username]);
  return null;
}
